"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformJournalEntryAccountParsedResponse = exports.transformJournalEntryAccountListResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Date_1 = require("./Date");
const Error_1 = require("./Error");
const SubAccount_1 = require("./SubAccount");
function transformJournalEntryAccountListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { journal_entry_accounts, per_page, total, page, pages } = response.response.result;
    return {
        journalEntryAccounts: journal_entry_accounts.map((account) => transformJournalEntryAccountParsedResponse(account)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformJournalEntryAccountListResponse = transformJournalEntryAccountListResponse;
function transformJournalEntryAccountParsedResponse(account) {
    return {
        accountName: account.account_name,
        accountNumber: account.account_number,
        accountType: account.account_type,
        accountId: account.accountid,
        accountingSystemId: account.accounting_systemid,
        balance: account.balance ? Number(account.balance) : account.balance,
        createdAt: account.created_at && (0, Date_1.transformDateResponse)(account.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        currencyCode: account.currency_code,
        id: account.id,
        subAccounts: account.sub_accounts &&
            account.sub_accounts.map((subAccount) => (0, SubAccount_1.transformSubAccountParsedResponse)(subAccount)),
    };
}
exports.transformJournalEntryAccountParsedResponse = transformJournalEntryAccountParsedResponse;
//# sourceMappingURL=JournalEntryAccount.js.map